// extracted by mini-css-extract-plugin
module.exports = {"ChatMessagePane":"ChatMessagePane_ChatMessagePane__Axk6i"};